module.exports = __webpack_public_path__ + "img/smart-cube-mark.5a292189.png";